module.exports = __webpack_public_path__ + "img/bgtop.6269ee71.jpg";